import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, DestroyRef, OnInit, ViewContainerRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { User } from '../../models/user';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { ModalService } from '../../services/modal/modal.service';
import { UserService } from '../../services/user/user.service';

@Component({
  selector: 'app-update-user',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './update-user.component.html',
  styleUrl: './update-user.component.scss',
})
export class UpdateUserComponent implements OnInit {
  error?: string;
  form!: FormGroup;
  submitting: boolean = false;
  resetEmail!: string;
  resetting: boolean = false;

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private authService: AuthenticationService,
    private modalService: ModalService,
    private vcr: ViewContainerRef,
    private router: Router,
    private destroyRef: DestroyRef
  ) {
    this.form = fb.group({
      uid: fb.control(''),
      username: fb.control('', [Validators.required, Validators.minLength(4)]),
      email: fb.control('', [Validators.required, Validators.email]),
    });
  }

  ngOnInit(): void {
    let userRaw = localStorage.getItem('edit');

    if (userRaw == null) {
      this.router.navigateByUrl('dashboard/users');
    } else {
      localStorage.removeItem('edit');
      let user: User = JSON.parse(userRaw);
      this.resetEmail = user.email;
      this.form.controls['uid'].setValue(user.uid);
      this.form.controls['username'].setValue(user.username);
      this.form.controls['email'].setValue(user.email);
    }
  }

  updateUser() {
    if (this.form.valid) {
      this.error = undefined;
      this.submitting = true;

      this.userService
        .updateUser(this.form.value)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: () => {
            this.submitting = false;

            if (
              this.authService.currentUser.value.uid ==
              this.form.controls['uid'].value
            ) {
              this.authService.updateCurrentUser(this.form.value);
            }

            this.form.reset();
            this.router.navigateByUrl('dashboard/users');
          },
          error: (err: HttpErrorResponse) => {
            if (err.status == 401) {
              this.authService.logout();
            } else {
              this.submitting = false;
              this.error = err.error.message;
            }
          },
        });
    } else {
      this.error = 'Please fill all field properly.';
    }
  }

  resetPassword() {
    this.resetting = true;
    this.userService.forgottenPassword(this.resetEmail).subscribe({
      next: () => {
        this.modalService.showSuccessDialog(
          this.vcr,
          'Password reset email was sent.'
        );
        this.resetting = false;
      },
      error: (err: HttpErrorResponse) => {
        this.error = err.error.message;
        this.resetting = false;
      },
    });
  }
}
